import { ColumnDef } from "@tanstack/react-table";
import { BackofficeUser } from "@/endpoints/dryp/backoffice";
import { ActionsMenuColumn } from "@/components/tableColumns/ActionsMenuColumn";
import { useMemo } from "react";
import { useStore } from "@/hooks/useStore";

export function useBackofficeUserColumns(refresh: () => void): ColumnDef<BackofficeUser>[] {
	const {
		uiStore: { modalStore },
	} = useStore();

	return useMemo(
		() => [
			{
				accessorKey: "id",
				header: "ID",
			},
			{
				accessorKey: "userName",
				header: "Username",
			},
			{
				accessorKey: "email",
				header: "Email",
			},
			{
				accessorKey: "organizationCount",
				header: "Organizations",
			},
			ActionsMenuColumn<BackofficeUser>({
				actions: [
					{
						label: "Manage Organizations",
						onSelect: row => {
							modalStore.open("assignOrganizations", {
								user: row.original,
								onSuccess: refresh,
							});
						},
					},
					{
						label: "Change Primary Organization",
						onSelect: row => {
							modalStore.open("setPrimaryOrganization", {
								user: row.original,
								onSuccess: refresh,
							});
						},
					},
					{
						label: "Change Password",
						onSelect: row => {
							modalStore.open("changePassword", {
								user: row.original,
								onSuccess: refresh,
							});
						},
					},
				],
				header: "",
				className: "w-10",
			}),
		],
		[],
	);
}
